import { render, staticRenderFns } from "./small-footer.vue?vue&type=template&id=2cedcb9f&scoped=true&"
import script from "./small-footer.vue?vue&type=script&lang=js&"
export * from "./small-footer.vue?vue&type=script&lang=js&"
import style0 from "./small-footer.vue?vue&type=style&index=0&id=2cedcb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cedcb9f",
  null
  
)

component.options.__file = "small-footer.vue"
export default component.exports